import { computed } from 'vue'

import {
  isFullSuperAdminProfileType,
  isSuperAdminLimitedProfileType,
  isSuperAdminProfileType,
} from '@/features/currentUser/constants'

import { useAuthStore } from '../auth/useAuthStore'

export function isSuperAdmin(myDetailsResponse) {
  return isSuperAdminProfileType(myDetailsResponse?.type)
}

export function useSuperAdminIdentity() {
  const authStore = useAuthStore()
  const myDetails = computed(() => authStore.myDetails)

  const isSuperAdminUser = computed(() => isSuperAdmin(myDetails.value))
  const isFullSuperAdminUser = computed(() => isFullSuperAdminProfileType(myDetails.value?.type))
  const isSuperAdminLimitedUser = computed(() =>
    isSuperAdminLimitedProfileType(myDetails.value?.type),
  )

  return {
    myDetails,
    isSuperAdmin: isSuperAdminUser,
    isFullSuperAdmin: isFullSuperAdminUser,
    isSuperAdminLimited: isSuperAdminLimitedUser,
  }
}

export function useIsSuperAdmin() {
  const { isSuperAdmin } = useSuperAdminIdentity()

  return isSuperAdmin.value
}
